import { EndpointBotLinkModel } from "../schema/endpoint-bot-link.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class EndpointBotLinkContainer extends MongoBaseContainer{
    endpoint_bot_link: EndpointBotLinkModel
}